import { render, staticRenderFns } from "./TraxUiTableWithActions.vue?vue&type=template&id=10919a1c"
import script from "./TraxUiTableWithActions.vue?vue&type=script&lang=js"
export * from "./TraxUiTableWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports